export default "__VITE_ASSET__21dba9eb__"